import React from 'react';
import { IconProps } from '.';

const SvgCircleInfoFillBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm-1.25 10v7h2.5v-7h-2.5Zm0-5v2.5h2.5V6h-2.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleInfoFillBold;
